export function getQueryParams() {
    if (typeof window === 'undefined') return new URLSearchParams()
    return new URLSearchParams(window.location.search)
}

export function clearQueryParams(keys = []) {
    if (typeof window === 'undefined') return

    const params = new URLSearchParams(window.location.search)
    let changed = false

    keys.forEach((key) => {
        if (params.has(key)) {
            params.delete(key)
            changed = true
        }
    })

    if (!changed) return

    const nextQuery = params.toString()
    const nextUrl = `${window.location.pathname}${nextQuery ? `?${nextQuery}` : ''}${window.location.hash || ''}`
    window.history.replaceState(window.history.state, '', nextUrl)
}
